import "./App.css";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";

import { JourneyContextProvider } from "./hooks/useJourney";

import LandingPage from "./Screens/LandingPage";
import AddBookingPage from "./Screens/AddBookingPage/";
import UpdateBookingPage from "./Screens/UpdateBookingPage/";
import BookingConfirmed from "./Screens/BookingConfirmed/BookingConfirmed";

const App = () => {
  return (
    <ChakraProvider>
      <BrowserRouter>
        <JourneyContextProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/add-booking" element={<AddBookingPage />} />
            <Route path="/update-booking" element={<UpdateBookingPage />} />
            <Route path="*" element={<LandingPage />} />
            <Route path="/booking-confirmed" element={<BookingConfirmed />} />
          </Routes>
        </JourneyContextProvider>
      </BrowserRouter>
    </ChakraProvider>
  );
};

export default App;
